// External
import React, { PureComponent } from 'react';

class TableInput extends PureComponent {
  render() {
    const { isItemSelected, value, onChange, placeholder } = this.props;

    return (
      <td className='quarter-width'>
        <div className="input-field" onClick={ (e) => e.stopPropagation() }>
          <input
            className={ `${isItemSelected ? 'selected' : ''}` } type="text"
            value={ value }
            onChange={ onChange }
            placeholder={ placeholder }
          />
        </div>
      </td>
    );
  }
}

export default TableInput;



// WEBPACK FOOTER //
// ./src/components/table-input/index.js